const defaultData = {
  sentiment: {
    level: "",
    emoji: "",
    message: "",
    color: "#ccc",
  },

  emailInfo: {
    from: "",
    email: "",
    phone: "",
    policyMentioned: "",
  },

  salesforceContext: {
    matchFound: true,
    contact: "John Smith",
    account: "Smith Household",
    clientSince: "March 2019",
    openCases: 0,
  },

  activePolicies: [
    {
      id: 1,
      type: "Auto Policy",
      icon: "🚗",
      status: "Active",
      policyNumber: "PA-2024-78432",
      carrier: "Progressive",
      premium: "$1,850/yr",
      expiration: "06/15/2026",
      details: "$500 Comp / $1,000 Collision Ded",
    },
    {
      id: 2,
      type: "Home Policy",
      icon: "🏠",
      status: "Active",
      policyNumber: "HO-2024-12890",
      carrier: "State Farm",
      premium: "$2,400/yr",
      expiration: "06/15/2026",
      details: "$1,000 Deductible",
    },
  ],

  crossSell: {
    count: 1,
    opportunities: [
      {
        id: 1,
        type: "Umbrella Policy",
        icon: "☂️",
        description:
          "Client has home + auto but no umbrella. With $300K+ in assets, recommend $1M umbrella for ~$350/yr.",
      },
    ],
  },
};

export default defaultData;
